import { useEffect, useCallback } from 'react';
import { useRouter } from 'next/router';
import { useKarteViewEvent } from '~/hooks/tracking/useKarteViewEvent';

export const useRouteChangeCompleteListener = () => {
  const router = useRouter();
  const sendKarteViewEvent = useKarteViewEvent();
  const handleRouteChange = useCallback(() => {
    sendKarteViewEvent();
  }, [sendKarteViewEvent]);

  useEffect(() => {
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [handleRouteChange, router.events, sendKarteViewEvent]);
};
